import { merge } from 'lodash/fp';

// these should be lazy loaded in
import stateMapData from 'config/geoJson/us-all-territories.geo.json';
import countyMapData from 'config/geoJson/us-all-all.geo.json';
import worldData from 'config/geoJson/world-robinson.geo.json';

const baseConfig = {
  chart: {
    style: {
      fontFamily: '"Source Sans Pro", serif',
    },
    height: `${(3 / 4) * 100}%`,
  },
  legend: {
    layout: 'horizontal',
    squareSymbol: true,
    symbolRadius: 0,
    symbolHeight: 16,
    symbolWidth: 16,
    padding: 0,
    margin: 16,
    itemDistance: 8,
    align: 'left',
    verticalAlign: 'top',
    backgroundColor: '#FFFFFF',
    width: '100%',
    x: 50,
    labelFormatter() {
      if (this.from !== this.to) {
        return `${this.from} - ${this.to}`;
      }
      return this.from;
    },
  },
  credits: {
    enabled: false,
  },
  title: {
    text: null,
  },
  exporting: {
    enabled: false,
  },
  mapNavigation: {
    enabled: true,
  },
  plotOptions: {
    map: {
      allAreas: false,
      dataLabels: {
        enabled: true,
        style: {
          color: 'contrast',
          fontWeight: 'bold',
          textOutline: 'none',
        },
      },
      tooltip: {
        headerFormat: '',
        pointFormat: '{point.name}: <b>{point.formattedValue}</b>',
      },
    },
  },
};

export const stateMap = merge(baseConfig, {
  chart: {
    map: 'countries/us/custom/us-all-territories',
  },
  mapData: stateMapData,
});

export const countyMap = merge(baseConfig, {
  plotOptions: {
    series: {
      allAreas: true,
    },
    mapline: {
      enableMouseTracking: false,
    },
    map: {
      allAreas: true,
      dataLabels: false,
    },
  },
  mapNavigation: {
    enabled: true,
  },
  chart: {
    map: 'countries/us/app-all-all',
  },
  mapData: countyMapData,
});

export const worldMap = merge(baseConfig, {
  mapNavigation: {
    enabled: true,
  },
  chart: {
    map: 'custom/world-robinson-lowres',
  },
  mapData: worldData,
});

export default {
  stateMap,
  countyMap,
  worldMap,
};



// WEBPACK FOOTER //
// ./app/config/mapConfig.js